import React, { Component } from "react";
import { connect } from "react-redux";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import ProjectListContainer from "./ProjectListContainer";
import ProjectDetailsContainer from "./ProjectDetailsContainer";
import ProjectFormContainer from "./ProjectFormContainer";
import ContactFormContainer from "./ContactFormContainer";

import { SecondaryButton } from '../Ui'
import LoadingOverlay from "../common/components/LoadingOverlay";
import Modal from "../common/components/Modal";

import FAQ from "../faq/FAQContainer";

import Icon from "../common/components/Icon";

import { getIsAuthenticated } from '../reducers/user';
import { getProjects } from "../webAPI/MKSService";


class ProjectRoute extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isFetching			: false,
			isProjectFormOpen	: false,
			isContactFormOpen	: false,
			projectFormMode		: "creation", // edition, duplication
			selectedProjectId	: "",
		}

		this.fetchProjects			= this.fetchProjects.bind(this);
		this.setSelectedProjectId	= this.setSelectedProjectId.bind(this);
		this.getSelectedProject		= this.getSelectedProject.bind(this);
		this.openProjectForm		= this.openProjectForm.bind(this);
		this.closeProjectForm		= this.closeProjectForm.bind(this);
		this.openContactForm		= this.openContactForm.bind(this);
		this.closeContactForm		= this.closeContactForm.bind(this);
	}

	componentWillMount() {
		const { isAuthenticated } = this.props;

		if(isAuthenticated) {
			this.fetchProjects()
		}
	}

	fetchProjects() {
		this.setState({ isFetching: true });
		getProjects().then(
			(error) => { /* Error */ },
			(result) => {
				const notEmpty = result.length !== 0;
				this.setState({
					isFetching: false,
					selectedProjectId: notEmpty ? result[0].project_id : "" // Select the first project by default
				});
				this.props.dispatch({
					type: "GET_PROJECTS_SUCCESS",
					result
				});
			}
		);
	}

	setSelectedProjectId(selectedProjectId) {
		this.setState({ selectedProjectId })
	}

	getSelectedProject() {
		for(let i = 0; i < this.props.projects.length; i++) {
			if(this.props.projects[i].project_id === this.state.selectedProjectId) {
				return this.props.projects[i];
			}
		}
		// return this.props.projects.find(project =>
		// 	project.project_id === this.state.selectedProjectId
		// );
	}

	openProjectForm(projectFormMode) {
		this.setState({
			projectFormMode,
			isProjectFormOpen: true
		});
	}

	closeProjectForm() {
		this.setState({
			isProjectFormOpen	: false,
			projectFormMode		: "creation"
		});
	}

	openContactForm() {
		this.setState({ isContactFormOpen: true });
	}

	closeContactForm() {
		this.setState({ isContactFormOpen: false });
	}

	render() {

		let UIState = "";

		if(this.state.isFetching) {
			UIState = "loading";
		} else if(this.props.projects.length === 0) {
			UIState = "blank";
		} else {
			UIState = "ideal";
		}

		// if(UIState === "empty") {

		// }

		// if(UIState === "ideal") {

		// }
			//const projects = [{name: "█████"}, {name: "███████"}, {name: "█████"}]
			//const project = {name: "█████", city: "█████", date_of_receipt: "█████", is_protected: "█████", a2p: "█████", surface_treatment_code: "█████", email: "█████", comment: "█████"};

		return (
			<div className="project-route">
				<ProjectListContainer
					UIState={UIState}
					projects={this.props.projects}
					selectedProjectId={this.state.selectedProjectId}
					openProjectForm={this.openProjectForm}
					onClick={this.setSelectedProjectId} />
				<div style={{width: "80%"}}>
					<div style={{marginBottom: "30px"}}>
						<ProjectDetailsContainer
							UIState={UIState}
							project={this.getSelectedProject()}
							onClick={this.openProjectForm} />
					</div>
					<div className="u-flex u-flex--justify-between">
						<SecondaryButton
							disabled={this.props.projects.length === 0}
							onClick={this.openContactForm}>

							Souhaitez-vous une extension ?
						</SecondaryButton>
						<FAQ />
					</div>
				</div>

				<Modal
					isOpen={this.state.isProjectFormOpen}
					closeOnClickOutside
					closeOnEsc
					onClose={this.closeProjectForm}>

					<ProjectFormContainer
						project={this.state.projectFormMode === "edition" || this.state.projectFormMode === "duplication"  ? this.getSelectedProject() : null}
						isOpen={this.state.isProjectFormOpen}
						formMode={this.state.projectFormMode}
						onClose={this.closeProjectForm} />
				</Modal>

				<ContactFormContainer
					projectId={this.state.selectedProjectId}
					isOpen={this.state.isContactFormOpen}
					onClose={this.closeContactForm} />

				<LoadingOverlay show={this.state.isFetching} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user,
		isAuthenticated: getIsAuthenticated(state),
		projects: state.projects
	};
}

export default connect(mapStateToProps)(ProjectRoute);



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectRoute.js